import type { BlockMentionValues, ResourceBlock } from '@root/@types/types';
import { replaceMention } from '@root/helpers/mentions/replace-mention';

export const handleReplaceMentionValues = (
  block: ResourceBlock,
  mentionValues?: BlockMentionValues,
): string | undefined => {
  if (!mentionValues) {
    return block.content;
  }

  const blockLinkedDatapoints = block.linkedDatapoints?.map(({ id }) => id) ?? [];
  const linkedDatapointIds = [...Object.keys(mentionValues), ...blockLinkedDatapoints];

  if (block?.deleted_at) {
    return block.content;
  }

  let parsedContent = block.content ?? '';

  linkedDatapointIds.forEach((id) => {
    parsedContent = replaceMention(id, mentionValues[id], parsedContent) ?? parsedContent;
  });

  return parsedContent;
};
